import React, { useEffect, useState } from 'react';
import { Alert, Box } from '@mui/material';
import LcaDriagramManagement from 'src/Lca/LCADiagram/Management';
import LCADiagram from 'src/Lca/LCADiagram';
import MonteCarloDiagram from 'src/Lca/LCADiagram/MonteCarloDiagram';
import ScenarioSimulationPanel from 'src/Lca/LCADiagram/ScenarioSimulationPanel';
import {
  DEFAULT_SCENARIO_CONTROLS,
  SavedScenario,
} from 'src/Lca/LCADiagram/analytics';

import { LcaManagementTab } from 'src/Lca/LCADiagram/Management/index.types';
import ImpactGrid from 'src/Lca/ImpactGrid';
import { useTranslation } from 'react-i18next';
import { useEcoinventProLicenceValid } from 'src/Lca/hooks';
import { useIsLcaPartialResults, useIsLcaPartialResultsGlobal } from '../utils';

export default function Diagram({ productId }: { productId: number }) {
  const [tab, setTab] = useState<LcaManagementTab>(LcaManagementTab.FLOWCHART);
  const [scenarioControls, setScenarioControls] = useState(
    DEFAULT_SCENARIO_CONTROLS
  );
  const [savedScenarios, setSavedScenarios] = useState<SavedScenario[]>([]);

  const { isEcoinventLicenceValid } = useEcoinventProLicenceValid();

  const { t } = useTranslation('lca');
  const isLcaPartialResults = useIsLcaPartialResults(productId);
  const isUseIsLcaPartialResultsGlobal =
    useIsLcaPartialResultsGlobal(productId);

  useEffect(() => {
    setScenarioControls(DEFAULT_SCENARIO_CONTROLS);
    setSavedScenarios([]);
  }, [productId]);

  return (
    <Box sx={{ padding: 1.25, width: '100%', maxWidth: '100%' }}>
      <LcaDriagramManagement productId={productId} tab={tab} setTab={setTab} />

      {!isEcoinventLicenceValid && (
        <>
          <br />
          <Alert severity="info">{t('diagram.noValidLicenceNoDetails')}</Alert>
        </>
      )}

      {(isLcaPartialResults ||
        (isUseIsLcaPartialResultsGlobal &&
          tab === LcaManagementTab.IMPACT)) && (
        <>
          <br />
          <Alert severity="warning">{t('partialLcaResults')}</Alert>
        </>
      )}

      {tab === LcaManagementTab.FLOWCHART && (
        <Box sx={{ minWidth: 0, overflowX: 'auto' }}>
          <LCADiagram productId={productId} />
        </Box>
      )}
      {tab === LcaManagementTab.IMPACT && <ImpactGrid />}
      {tab === LcaManagementTab.ANALYTICS && (
        <>
          <ScenarioSimulationPanel
            productId={productId}
            controls={scenarioControls}
            onControlsChange={setScenarioControls}
            savedScenarios={savedScenarios}
            onSavedScenariosChange={setSavedScenarios}
          />
          <MonteCarloDiagram
            productId={productId}
            scenarioControls={scenarioControls}
          />
        </>
      )}
    </Box>
  );
}
